import React from 'react'
import './style.css'
import MaterialIcons from 'material-icons-react'
import {Link} from 'react-router-dom'

export default (props) =>{
    
    let p = window.location.pathname.split('/')[1]
    let {nome, paginas}  = props
    let sair = () =>{
        props.feedback('Você deslogou com sucesso');
        props.sair();
        props.history.push('/')
    }
    console.log('111111111111 header',props, p);
    return (
    <div className='administrativo_header'>
        <span className='nome_site'>{nome}</span>
        <span className='nome_area'>{p=='adm'?'Área administrativa':''}</span>
            <div className='sidebar'>
                <div className='categoria_sidebar'>
                    <Link to="/adm" className='header'>Bem Vindo!</Link>
                </div>
                <div className='categoria_sidebar'>
                    <Link to="/adm/imagenslocais" className='header'>Imagens</Link>
                </div>
                <div className='categoria_sidebar'>
                    <h2 className='header'>Páginas<small> de conteúdo</small></h2>
                    {paginas.map((obj,k) =>
                        <Link key={k} to={'/adm/paginas/'+obj.id}>{obj.nome}</Link>
                    )}
                    <Link className='add_pagina' to='/adm/paginas/novo'><MaterialIcons icon='add'/></Link>
                </div>
                <div className='categoria_sidebar'>
                    <Link to="/adm/informacoes" className='header'>Informações Institucionais</Link>
                </div>
                <div className='categoria_sidebar'>
                    <Link to="/adm/mapa" className='header'>Estado de Vendas</Link>
                </div>
                <div className='categoria_sidebar'>
                    <Link to="/adm/corretores" className='header'>Corretores</Link>
                </div>
            </div>
        <div className='botao_sair' onClick={sair}>
            <MaterialIcons icon='exit_to_app'/>
        </div>
    </div>
)
}


// WEBPACK FOOTER //
// ./src/views/administrativo/header/component.js